import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-website-terms',
  templateUrl: './website-terms.component.html',
  styleUrls: ['./website-terms.component.scss']
})
export class WebsiteTermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
